export const VTMN_RATING_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
};
